exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.spinner[data-v-b5102d4e] {\n  align-content: center;\n}\n", ""]);

// exports
